var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"m-4"},[_c('FilingClassificationPlanTree',{attrs:{"mode":_vm.mode,"reset":_vm.treeResetKey,"structureId":_vm.structureId,"isForAddEditDeleteControl":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }